import { ANIMATION_DURATION } from "components/Message/configs";
import { breakpoints, Button, Heading } from "iparque-components";
import styled, { css } from "styled-components";

interface ContainerProps {
  isVisible: boolean;
  isFormVisible: boolean;
}

interface StyledButtonProps {
  isFormVisible: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: ${({ isVisible }) => (isVisible ? "relative" : "absolute")};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity ${ANIMATION_DURATION};
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.md}) {
    #heading {
      transform: translateY(
        ${({ isFormVisible }) => (isFormVisible ? 25 : 0)}px
      );
      transition: transform ${ANIMATION_DURATION};
    }
  }
`;

export const StyledHeading = styled(Heading)`
  line-height: 1em;
`;

export const StyledButton = styled(Button)<StyledButtonProps>`
  align-self: center;
  transition: opacity ${ANIMATION_DURATION};
  padding: 0.4rem 1rem;

  ${({ isFormVisible }) =>
    isFormVisible
      ? css`
          opacity: 0;
          pointer-events: none;
        `
      : css`
          opacity: 1;
          pointer-events: initial;
        `}
`;
